export const DEPOSIT_AMOUNT_MIN_VALUE = 1.0;
export const DEPOSIT_AMOUNT_MAX_VALUE = 99.99;
export const DEPOSIT_EXPIRY_DAYS_MIN_VALUE = 1;
export const DEPOSIT_EXPIRY_DAYS_MAX_VALUE = 500;
